///* REAL 250P120322
import React, {useState, useRef} from 'react';
import {Container, Card, CardContent, makeStyles, Grid, TextField, Button} from '@material-ui/core';
import QRCode from 'qrcode';
import QrReader from 'react-qr-reader';


function App() { 
  const [text, setText] = useState('');
  const [imageUrl, setImageUrl] = useState('');
  const [scanResultFile, setScanResultFile] = useState('');
  const [scanResultWebCam, setScanResultWebCam] =  useState('');
  const classes = useStyles();
  const qrRef = useRef(null);
  const [navegacionScan, setNavegacionScan] =  useState('');


  const generateQrCode = async () => {
    try {
          const response = await QRCode.toDataURL(text);
          setImageUrl(response);
    }catch (error) {
      console.log(error);
    }
  }
  const handleErrorFile = (error) => {
    console.log(error);
  }
  const handleScanFile = (result) => {
      if (result) {
          setScanResultFile(result);
      }
  }
  const onScanFile = () => {
    qrRef.current.openImageDialog();
  }
  const handleErrorWebCam = (error) => {
    console.log(error);
  }
  const handleScanWebCam = (result) => {
    if (result){
        setScanResultWebCam(result);
    }
   }

   let agWww = "www."
   let agHttp = "https://"
   let agHttpWww = "https://www."   
 
   function funUnir()
   {
 
     if 
     (scanResultWebCam.indexOf('http') === 0)
       {
         //document.write("navegando1");   
         console.log("Todo bien");  
       }
     
     else if
     (scanResultWebCam.indexOf('http')=== -1)
       {
       if 
       (scanResultWebCam.indexOf('www.') === 0)
         {
           let resultUno = agHttp + scanResultWebCam;
           //document.write(resultUno); 
           console.log(resultUno + " se agrego http");
           setNavegacionScan(resultUno)
         }
       else if
       (scanResultWebCam.indexOf('www.')=== -1)
         {
           let resultDos = agHttpWww + scanResultWebCam;
           //document.write(resultDos);
           console.log(resultDos + " se agrego http y www");
           setNavegacionScan(resultDos)
         } 
       }
   }  
 

  return (
    <Container className={classes.conatiner}>
          <Card>
              <img style={{backgroundColor:'black', height:'60px', width:'100%' }}
              src='https://firebasestorage.googleapis.com/v0/b/restaurants-e6e97.appspot.com/o/recursos%2FlogoToyaFondosOscuros2.svg?alt=media&token=cfbb5b4a-f216-493d-93cd-a9815fb0237e'/>
              <div style={{ justifyContent: 'center', alignItems: 'center', display: 'flex',backgroundColor:'white', height:'40px', width:'100%' }}>
              <h3 style={{color:'black', fontSize:'25px'}}>QR Scanner and Generator</h3>
              </div>
              <CardContent>
                  <Grid container spacing={2}>
                      <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                         <QrReader
                         delay={300}
                         style={{width: '100%'}}
                         onError={handleErrorWebCam}
                         onScan={handleScanWebCam}
                         />
                         <h3>Scanned Code: {scanResultWebCam}</h3>
                         <div style={{ alignItems:'center', justifyContent:'center', display:'flex'}}>
                         <Button 
                         style={{width:'200px', marginTop: '5px',marginBottom: '5px'}}
                         variant="contained" 
                         color="secondary" 
                         href= {scanResultWebCam}
                         onClick={console.log("navegando")}
                         >Navigate to link
                         </Button>
                         </div>
                      </Grid>
                      <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <div style={{ alignItems:'center', justifyContent:'center', display:'flex', flexDirection:'column'}}>
                          <TextField label="Enter your text" onChange={(e) => setText(e.target.value)}/>
                          <Button 
                          style={{width:'200px', marginTop: '10px',marginBottom: '5px'}}
                          variant="contained" 
                            color="primary" onClick={() => generateQrCode()}>Generate Qr</Button>
                            <br/>
                            <br/>
                            <br/>
                            {imageUrl ? (
                              <a href={imageUrl} download>
                                  <img src={imageUrl} alt="img"/>
                              </a>) : null}
                      </div>        
                      </Grid>
                  </Grid>
              </CardContent>
          </Card>
    </Container>
  );
}

const useStyles = makeStyles((theme) => ({
    conatiner: {
      marginTop: 10
    },
    title: {
      display: 'flex',
      justifyContent: 'center',
      alignItems:  'center',
      background: '#3f51b5',
      color: '#fff',
      padding: 5
    },
    btn : {
      marginTop: 10,
      marginBottom: 20,
      width: '200px'
    }
}));
export default App;
//*/

/*
import React, {useState, useRef} from 'react';
import {Container, Card, CardContent, makeStyles, Grid, TextField, Button} from '@material-ui/core';
import QRCode from 'qrcode';
import QrReader from 'react-qr-reader';


function App() { 
  const [text, setText] = useState('');
  const [imageUrl, setImageUrl] = useState('');
  const [scanResultFile, setScanResultFile] = useState('');
  const [scanResultWebCam, setScanResultWebCam] =  useState('');
  const classes = useStyles();
  const qrRef = useRef(null);


  const generateQrCode = async () => {
    try {
          const response = await QRCode.toDataURL(text);
          setImageUrl(response);
    }catch (error) {
      console.log(error);
    }
  }
  const handleErrorFile = (error) => {
    console.log(error);
  }
  const handleScanFile = (result) => {
      if (result) {
          setScanResultFile(result);
      }
  }
  const onScanFile = () => {
    qrRef.current.openImageDialog();
  }
  const handleErrorWebCam = (error) => {
    console.log(error);
  }
  const handleScanWebCam = (result) => {
    if (result){
        setScanResultWebCam(result);
    }
   }
  return (
    <div style={{padding:'200px', backgroundColor:'red'}}>
          <div style={{padding:'50px', backgroundColor:'blue'}}>
              <h3 className={classes.title}>Lector y Generador QR</h3>
              <img style={{padding:'50px', backgroundColor:'gray', height:'40px', width:'100%' }}
              src='https://firebasestorage.googleapis.com/v0/b/restaurants-e6e97.appspot.com/o/recursos%2FlogoToyaPalm.svg?alt=media&token=99951dd4-454e-412b-a1ab-edddf4328d52'/>
              <div style={{padding:'50px', backgroundColor:'green'}}>
                  <div style={{padding:'50px', backgroundColor:'gray'}}>
                      <div style={{padding:'50px', backgroundColor:'yellow'}}>
                         <QrReader
                         delay={300}
                         style={{width: '100%'}}
                         onError={handleErrorWebCam}
                         onScan={handleScanWebCam}
                         />
                         <h3>Codigo Escaneado: {scanResultWebCam}</h3>
                      </div>
                      <div style={{padding:'50px', backgroundColor:'orange'}}>
                          <TextField label="Enter Text Here" onChange={(e) => setText(e.target.value)}/>
                          <Button style={{backgroundColor:'red'}} variant="contained" 
                            color="primary" onClick={() => generateQrCode()}>Generar Qr</Button>
                            {imageUrl ? (
                              <a href={imageUrl} download>
                                  <img src={imageUrl} alt="img"/>
                              </a>) : null}
                      </div>
                  </div>
              </div>
          </div>
    </div>
  );
}
// height:'500px',
const useStyles = makeStyles((theme) => ({
    conatiner: {
      marginTop: 10
    },
    title: {
      display: 'flex',
      justifyContent: 'center',
      alignItems:  'center',
      background: '#3f51b5',
      color: '#fff',
      padding: 5
    },
    btn : {
      marginTop: 10,
      marginBottom: 20
    }
}));
export default App;
*/

/*
import React, {useState, useRef} from 'react';
import {Container, Card, CardContent, makeStyles, Grid, TextField, Button} from '@material-ui/core';
import QRCode from 'qrcode';
import QrReader from 'react-qr-reader';


function App() { 
  const [text, setText] = useState('');
  const [imageUrl, setImageUrl] = useState('');
  const [scanResultFile, setScanResultFile] = useState('');
  const [scanResultWebCam, setScanResultWebCam] =  useState('');
  const classes = useStyles();
  const qrRef = useRef(null);


  const generateQrCode = async () => {
    try {
          const response = await QRCode.toDataURL(text);
          setImageUrl(response);
    }catch (error) {
      console.log(error);
    }
  }
  const handleErrorFile = (error) => {
    console.log(error);
  }
  const handleScanFile = (result) => {
      if (result) {
          setScanResultFile(result);
      }
  }
  const onScanFile = () => {
    qrRef.current.openImageDialog();
  }
  const handleErrorWebCam = (error) => {
    console.log(error);
  }
  const handleScanWebCam = (result) => {
    if (result){
        setScanResultWebCam(result);
    }
   }
  return (
    <div style={{padding:'200px', backgroundColor:'red'}}>
          <div style={{padding:'50px', backgroundColor:'blue'}}>
              <h3 className={classes.title}>Lector y Generador QR</h3>
              <img style={{padding:'50px', backgroundColor:'gray', height:'40px', width:'100%' }}
              src='https://firebasestorage.googleapis.com/v0/b/restaurants-e6e97.appspot.com/o/recursos%2FlogoToyaPalm.svg?alt=media&token=99951dd4-454e-412b-a1ab-edddf4328d52'/>
              <div style={{padding:'50px', backgroundColor:'green'}}>
                  <div style={{padding:'50px', backgroundColor:'gray'}}>
                      <div style={{padding:'50px', backgroundColor:'yellow'}}>
                         <QrReader
                         delay={300}
                         style={{width: '100%'}}
                         onError={handleErrorWebCam}
                         onScan={handleScanWebCam}
                         />
                         <h3>Codigo Escaneado: {scanResultWebCam}</h3>
                      </div>
                      <div style={{padding:'50px', backgroundColor:'orange'}}>
                          <TextField label="Enter Text Here" onChange={(e) => setText(e.target.value)}/>
                          <Button style={{backgroundColor:'red'}} variant="contained" 
                            color="primary" onClick={() => generateQrCode()}>Generar Qr</Button>
                            {imageUrl ? (
                              <a href={imageUrl} download>
                                  <img src={imageUrl} alt="img"/>
                              </a>) : null}
                      </div>
                  </div>
              </div>
          </div>
    </div>
  );
}
// height:'500px',
const useStyles = makeStyles((theme) => ({
    conatiner: {
      marginTop: 10
    },
    title: {
      display: 'flex',
      justifyContent: 'center',
      alignItems:  'center',
      background: '#3f51b5',
      color: '#fff',
      padding: 5
    },
    btn : {
      marginTop: 10,
      marginBottom: 20
    }
}));
export default App;
*/


/*
                         <h3>Escanear QR</h3>

                      <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                        <Button className={classes.btn} variant="contained" color="secondary" onClick={onScanFile}>Scan Qr Code</Button>
                        <QrReader
                          ref={qrRef}
                          delay={300}
                          style={{width: '100%'}}
                          onError={handleErrorFile}
                          onScan={handleScanFile}
                          legacyMode
                        />
                        <h3>Scanned Code: {scanResultFile}</h3>
                      </Grid>
*/                      

/* 
import React, {useState, useRef} from 'react';
import {Container, Card, CardContent, makeStyles, Grid, TextField, Button} from '@material-ui/core';
import QRCode from 'qrcode';
import QrReader from 'react-qr-reader';

function App() { 
  const [text, setText] = useState('');
  const [imageUrl, setImageUrl] = useState('');
  const [scanResultFile, setScanResultFile] = useState('');
  const [scanResultWebCam, setScanResultWebCam] =  useState('');
  const classes = useStyles();
  const qrRef = useRef(null);

  const [navegacionScan, setNavegacionScan] =  useState('');

  const generateQrCode = async () => {
    try {
          const response = await QRCode.toDataURL(text);
          setImageUrl(response);
    }catch (error) {
      console.log(error);
    }
  }
  const handleErrorFile = (error) => {
    console.log(error);
  }
  const handleScanFile = (result) => {
      if (result) {
          setScanResultFile(result);
      }
  }
  const onScanFile = () => {
    qrRef.current.openImageDialog();
  }
  const handleErrorWebCam = (error) => {
    console.log(error);
  }
  const handleScanWebCam = (result) => {
    if (result){
        setScanResultWebCam(result);
    }
   }

  let agWww = "www."
  let agHttp = "https://"
  let agHttpWww = "https://www."   

  function funUnir()
  {

    if 
    (scanResultFile.indexOf('http') === 0)
      {
        //document.write("navegando1");   
        console.log("Todo bien");  
      }
    
    else if
    (scanResultFile.indexOf('http')=== -1)
      {
      if 
      (scanResultFile.indexOf('www.') === 0)
        {
          let resultUno = agHttp + scanResultFile;
          //document.write(resultUno); 
          console.log(resultUno + " se agrego http");
          setNavegacionScan(resultUno)
        }
      else if
      (scanResultFile.indexOf('www.')=== -1)
        {
          let resultDos = agHttpWww + scanResultFile;
          //document.write(resultDos);
          console.log(resultDos + " se agrego http y www");
          setNavegacionScan(resultDos)
        } 
      }
  }  
/*  
console.log(navegacionScan)
console.log("aqui navegacionScan")
*//*
  return (
    <Container className={classes.conatiner}>
          <Card>
              <h2 className={classes.title}>Generate Download & Scan QR Code with React js</h2>
              <CardContent>
                  <Grid container spacing={2}>
                      <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                          <TextField label="Enter Text Here" onChange={(e) => setText(e.target.value)}/>
                          <Button className={classes.btn} variant="contained" 
                            color="primary" onClick={() => generateQrCode()}>Generate</Button>
                            <br/>
                            <br/>
                            <br/>
                            {imageUrl ? (
                              <a href={imageUrl} download>
                                  <img src={imageUrl} alt="img"/>
                              </a>) : null}
                      </Grid>
                      <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                        <Button className={classes.btn} variant="contained" color="secondary" onClick={onScanFile}>Scan Qr Code</Button>
                        <QrReader
                          ref={qrRef}
                          delay={300}
                          style={{width: '100%'}} 
                          onError={handleErrorFile}
                          onScan={handleScanFile}
                          legacyMode
                        />
                        <h3>Scanned Code: {scanResultFile}</h3>
                        <Button className={classes.btn}
                        style={{width: '70%', marginTop: '5px',marginBottom: '5px'}}
                         variant="contained" 
                         color="secondary" 
                         onClick={onScanFile}
                         >Escanear Qr 
                         </Button>
                         <br/>
                         <Button className={classes.btn}
                        style={{width: '70%', marginTop: '5px',marginBottom: '5px'}}
                         variant="contained" 
                         color="secondary" 
                         href= {scanResultFile}
                         onClick={console.log("navegando")}
                         >Navegar a Enlace
                         </Button>
                         <br/>
                <h3>Código escaneado: {scanResultFile}</h3>
                      </Grid>
                      <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                         <h3>Qr Code Scan by Web Cam</h3>
                         <QrReader
                         delay={300}
                         style={{width: '100%'}}
                         onError={handleErrorWebCam}
                         onScan={handleScanWebCam}
                         />
                         <h3>Scanned By WebCam Code: {scanResultWebCam}</h3>
                      </Grid>
                 </Grid>
              </CardContent>
          </Card>
    </Container>
  );
}
                  

const useStyles = makeStyles((theme) => ({
    conatiner: {
      marginTop: 10,
      marginLeft: 'auto',
      marginRight: 'auto'
    },
    title: {
      display: 'flex',
      justifyContent: 'center',
      alignItems:  'center',
      background: '#3f51b5',
      color: '#fff',
      padding: 20
    },
    organizarBotones:{
      justifyContent:'column'
    },
    btn : {
      marginTop: 10,
      marginBottom: 20,
    }
}));
export default App;


                <Button className={classes.btn}
                style={{width: '70%', marginTop: '5px',marginBottom: '5px'}}
                variant="contained" 
                color="secondary" 
                onClick={
                    funUnir,
                    console.log(navegacionScan),
                    console.log("desde boton test")
                }
                >Test

                </Button>
*/
